import { BaseEntityDto, ScheduleEntryDto, ScheduleEntryEntityType } from "@/core/api/generated/v1";

import { assertNever } from "../ts/typeHelpers";

export class ScheduleHelper {
  public static getFullSourceEntityFromEntry(entry: ScheduleEntryDto) {
    if (!entry.sourceEntity?.entityType) {
      return null;
    }
    switch (entry.sourceEntity.entityType) {
      case ScheduleEntryEntityType.None:
        return undefined;
      case ScheduleEntryEntityType.Contract:
        return entry.sourceEntity?.contract;
      case ScheduleEntryEntityType.AssetSubscription:
        return entry.sourceEntity?.assetSubscription;
      case ScheduleEntryEntityType.AccessoryCheck:
        return entry.sourceEntity?.accessoryCheck;
      case ScheduleEntryEntityType.VisualInspection:
        return entry.sourceEntity?.visualInspection;
      case ScheduleEntryEntityType.DamageDetection:
        return entry.sourceEntity?.damageDetection;
      case ScheduleEntryEntityType.DamageCostEvaluation:
        return entry.sourceEntity?.damageCostEvaluation;
      case ScheduleEntryEntityType.RepairOperation:
        return entry.sourceEntity?.repairOperation;
      case ScheduleEntryEntityType.Wash:
        return entry.sourceEntity?.wash;
      case ScheduleEntryEntityType.WheelOperation:
        return entry.sourceEntity?.wheelOperation;
      case ScheduleEntryEntityType.Maintenance:
        return entry.sourceEntity?.maintenance;
      case ScheduleEntryEntityType.GeneralStatusHistory:
        return entry.sourceEntity?.generalStatusHistory;
      default:
        assertNever(entry.sourceEntity?.entityType);
    }
  }

  public static getFullSourceEntityFromEntryOrThrow(entry: ScheduleEntryDto): BaseEntityDto {
    const sourceEntity = this.getFullSourceEntityFromEntry(entry);
    if (!sourceEntity) {
      throw new Error("Schedule entry doesn't have source entity DTO.");
    }
    return sourceEntity;
  }
}
